const _ = require('lodash');
const moment = require('moment');
const DATE_FORMAT = 'YYYY-MM-DD';
const DATE_FORMAT_SPACE = 'D MMM YYYY';
const DATE_FORMAT_MIXPANEL = 'DD MMM YYYY';
const DATE_FORMAT_SPACE_REGEX = /^\d{1,2}\s[a-zA-Z\u0590-\u05FF\u200f\u200e]{3,4}\s\d{4}$/;
const CANCELLATION_DEADLINE_FORMAT_EN = 'MMM D, YYYY hh:mm A';
const CANCELLATION_DEADLINE_FORMAT_HE_DAY_MONTH = 'D [\u05d1]MMM';
const CANCELLATION_DEADLINE_FORMAT_HE_YEAR_TIME = 'YYYY, HH:mm';
const BIDI_LTR_ISOLATE = '\u2066';
const BIDI_POP_ISOLATE = '\u2069';
// Non-breaking spaces inside the isolated tail: if a line break splits it, the comma lands at the
// line edge and reads as leading punctuation. Keeping the tail whole means the value can only wrap
// before it, after the month.
const NO_BREAK_SPACE = '\u00a0';
const { SUPPORTED_LANGUAGES } = require('../../translation/const');

function getMixpanelString(date) {
    const new_date = getDateInFormat(date);

    return moment(new_date, DATE_FORMAT).locale(SUPPORTED_LANGUAGES.EN).format(DATE_FORMAT_MIXPANEL)
}

function getDateInFormat(date) {
    if (_.isNumber(date)) {
        // if unix format
        return moment(date).format(DATE_FORMAT);
    }

    if (_.isString(date) && DATE_FORMAT_SPACE_REGEX.test(date)) {
        // if format is different (D MMM YYYY)
        // can take english and hebrew format
        return moment(date, DATE_FORMAT_SPACE).format(DATE_FORMAT);
    }

    // return the date as is and dont change it by the utc time
    return moment(date, DATE_FORMAT).format(DATE_FORMAT);
}

function getDateInIso(date) {
    const normalized_date = getDateInFormat(date);
    const new_date = new Date(normalized_date)

    // create a date iso string without utc impact
    // use of regular toISOString can change the date becuase of utc calculation
    return new Date(new_date.getTime() - new_date.getTimezoneOffset() * 60000).toISOString()
}

function isValidDate(date) {
    return (Object.prototype.toString.call(date) === '[object Date]') && !isNaN(date.getTime());
}

function ensureIsoString(dateOrIsoString) {
    if (isValidDate(dateOrIsoString)) {
        return dateOrIsoString.toISOString();
    }

    const m = moment(toUTC(dateOrIsoString));
    if (m.isValid()) {
        return m.toISOString();
    }

    return dateOrIsoString;
}

function toUTC(d) {
    if (!_.isDate(d)) {
        d = moment(d, [moment.ISO_8601, 'YYYY-MM-DD', 'YYMMDD'], true).toDate();
    }

    return new Date(d.getTime() - d.getTimezoneOffset() * 60 * 1000);
}

// Parse the deadline as a UTC moment and adjust to the previous day at 11:59 PM(English) or 23:59(Hebrew)
function formatCancellationDeadline(deadline, language = SUPPORTED_LANGUAGES.EN) {
	if (!deadline) return null;

    const deadlineMoment = moment.utc(deadline).subtract(1, 'day').endOf('day');

	const isHebrew = language === SUPPORTED_LANGUAGES.HE;

	if (!isHebrew) {
		return `${deadlineMoment.format(CANCELLATION_DEADLINE_FORMAT_EN)} (GMT)`;
	}

	const dayAndMonth = deadlineMoment.format(CANCELLATION_DEADLINE_FORMAT_HE_DAY_MONTH);
	const yearAndTime = deadlineMoment
		.format(CANCELLATION_DEADLINE_FORMAT_HE_YEAR_TIME)
		.replace(/ /g, NO_BREAK_SPACE);

	return `${dayAndMonth} ${BIDI_LTR_ISOLATE}${yearAndTime}${NO_BREAK_SPACE}(GMT)${BIDI_POP_ISOLATE}`;
}

module.exports = {
    toUTC,
    dateToCheckInOutString: function (date) {
        if (date)
            return moment(date).format('DD MM YYYY');
    },

    reformatDate: function (date) {
        return moment(date).format(DATE_FORMAT);
    },

    parseFormatDate: function (date) {
        if (!date) return null;
        return moment.utc(date, DATE_FORMAT);
    },

    customDateOnlyParse: function (dateOrIsoString) {
        if (!dateOrIsoString) return null;

        try {
            const dateString = ensureIsoString(dateOrIsoString);
            const m = moment.utc(dateString.split('T')[0]);

            return m.isValid()
                ? m
                : dateOrIsoString;
        } catch (ex) {
            console.error(ex);

            return dateOrIsoString;
        }
    },
    getMixpanelString,
    getDateInFormat,
    getDateInIso,
    formatCancellationDeadline
};
